<template>
  <!-- app面板 -->
  <div class="app">
    <div class="app-color">
      <div class="phone">
        <div class="status-bar">
          <div class="time">15:43</div>
          <div class="icons">
            <img src="../../../../assets/images/phone-icon1.png" alt="" />
            <img src="../../../../assets/images/phone-icon2.png" alt="" />
          </div>
        </div>
        <div class="app-header">
          <div class="app-left">
            <img src="../../../../assets/images/phone-icon3.png" alt="" />
          </div>
          <div class="app-center">My DeeBike</div>
          <div class="app-right">
            <img src="../../../../assets/images/phone-icon4.png" alt="" />
          </div>
        </div>

        <div class="app-content">
          <div class="app-yuan">
            <div class="app-content-yuan">
              <div class="app-bike">
                <div class="fonts-icon">
                  <span
                    class="iconfont icon-lanya"
                    :style="{ color: ruleForm.appThemeColor }"
                  ></span
                  ><span
                    class="iconfont icon-Cellular4G-1"
                    :style="{ color: ruleForm.appThemeColor }"
                  ></span>
                </div>
                <div class="app-bike-image">
                  <img src="../../../../assets/images/app-bike.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="app-lock">
            <span
              class="iconfont icon-lock-full"
              :style="{ color: ruleForm.appThemeColor }"
            ></span>
          </div>
        </div>

        <div class="app-state">
          <div class="app-left-module">
            <div class="app-left-top">
              <span>Electricity</span
              ><span class="iconfont icon-dianchibattery142"></span>
            </div>
            <div class="app-percentage">80<span>%</span></div>
          </div>
          <div class="app-right-module">
            <div class="app-left-top">
              <span>Distance</span><span class="iconfont icon-ziyuan"></span>
            </div>
            <div class="app-percentage">45<span>KM</span></div>
          </div>
        </div>

        <div class="app-loop">
          <img src="../../../../assets/images/app-bike-loop.png" alt="" />
        </div>

        <div class="app-footer">
          <div>
            <span
              class="iconfont icon-zihangche"
              :style="{ color: ruleForm.appThemeColor }"
            ></span>
          </div>
          <div :style="{ background: ruleForm.appThemeColor }">GO</div>
          <div><span class="iconfont icon-wode"></span></div>
        </div>
      </div>

      <div class="color-select">
        <div class="title">
          <span>{{$t('pages.operate.text20')}}</span>
          <DiluButton type="reset" @click="reset"></DiluButton>
        </div>
        <div class="test">{{$t('pages.operate.text21')}}</div>
        <div class="select">
          <span>{{$t('pages.operate.text22')}}</span>
          <div class="color-list">
            <div
              v-for="(item, index) in predefineColors"
              :key="index"
              :style="{ background: item }"
              @click="selectColor(item)"
            ></div>
          </div>
        </div>
        <div class="select">
          <span>{{$t('pages.operate.text23')}}</span>
          <el-color-picker
            v-model="ruleForm.appThemeColor"
            show-alpha
            :predefine="predefineColors"
          >
          </el-color-picker>
        </div>
      </div>
    </div>
    <div class="info-button">
      <DiluButton type="prev" @click="prev"></DiluButton>
      <DiluButton type="custom" :title="$t('pages.operate.text24')" @click="submit"></DiluButton>
    </div>
  </div>
</template>


<script>
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
export default {
  data() {
    return {
      ruleForm: {
        appThemeColor: "#1F5BCC", //app界面主题色
      },
      predefineColors: [
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#c71585",
      ],
    };
  },
  watch: {
    activeName(newValue) {
      if (newValue == "AppPanel") {
        this.ruleForm.appThemeColor = this.params.appThemeColor;
      }
    },
  },
  props: ["activeName", "params", "pageState"],
  components: {
    DiluButton,
  },
  methods: {
    reset() {
      this.ruleForm.appThemeColor = "#1F5BCC";
    },
    submit() {
      this.ruleForm.appThemeColor = this.rgbToHex(this.ruleForm.appThemeColor).hex;
      this.$emit("submit", this.ruleForm);
    },
    prev() {
      this.$emit("prev");
    },
    selectColor(e) {
      this.ruleForm.appThemeColor = this.rgbToHex(e).hex;
    },
    rgbToHex(rgb) {
      var rRgba = /rgba?\((\d{1,3}),(\d{1,3}),(\d{1,3})(,([.\d]+))?\)/,
        r,
        g,
        b,
        a,
        rsa = rgb.replace(/\s+/g, "").match(rRgba);
      if (rsa) {
        r = (+rsa[1]).toString(16);
        r = r.length == 1 ? "0" + r : r;
        g = (+rsa[2]).toString(16);
        g = g.length == 1 ? "0" + g : g;
        b = (+rsa[3]).toString(16);
        b = b.length == 1 ? "0" + b : b;
        a = +(rsa[5] ? rsa[5] : 1) * 100;
        return { hex: "#" + r + g + b, alpha: Math.ceil(a) };
      } else {
        return { hex: rgb, alpha: 100 };
      }
    },
  },
};
</script>

<style scoped>
.app {
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.app-color {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.color-select {
  flex: 1;
  margin-left: 50px;
}
.select {
  display: flex;
  margin-bottom: 20px;
}
.select span {
  margin-right: 20px;
  display: block;
  width: 100px;
  text-align: end;
}
.color-list {
  display: flex;
  flex-wrap: wrap;
}
.color-list div {
  width: 29px;
  height: 29px;
  background: rgba(0, 0, 0, 0);
  opacity: 1;
  border-radius: 5px;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
.test {
  margin-bottom: 50px;
}
.info-button {
  margin: 40px 0;
  display: flex;
  justify-content: center;
}
.phone {
  width: 250px;
  height: 400px;
  background-image: url("../../../../assets/images/appBg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  flex-shrink: 0;
  padding: 20px 46px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #f2f4f8;
}
.status-bar {
  display: flex;
  justify-content: space-between;
}
.time {
  font-size: 12px;
  transform: scale(0.7);
}
.icons {
  display: flex;
  align-items: center;
}
.icons img {
  display: block;
  width: 12px;
  margin: 0 2px;
  transform: scale(0.7);
}
.app-header {
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
  box-sizing: border-box;
}
.app-center {
  font-size: 12px;
  transform: scale(0.7);
}
.app-left {
  width: 20px;
  height: 20px;
  box-shadow: 0.2rem 0.2rem 0.5rem #c8d0e7,
    -0.1rem -0.1rem 0.4rem rgb(250, 250, 250);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app-left img {
  width: 12px;
  display: block;
  transform: scale(0.7);
}
.app-right img {
  width: 12px;
  display: block;
  transform: scale(0.7);
}
.app-right {
  width: 20px;
  height: 20px;
  box-shadow: 0.2rem 0.2rem 0.5rem #c8d0e7,
    -0.1rem -0.1rem 0.4rem rgb(250, 250, 250);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app-content {
  display: flex;
  flex-direction: column;
}
.app-yuan {
  width: 140px;
  height: 140px;
  display: inline-block;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-bottom-color: #f2f4f8;
  border-left-color: #1f5bcc;
  border-top-color: #1f5bcc;
  border-radius: 50%;
  margin: auto;
  margin-top: 5px;
  position: relative;
}
.app-yuan::after {
  content: " ";
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #fff;
  top: 10px;
  right: 14px;
  box-shadow: 0.2rem 0.2rem 0.5rem #c8d0e7,
    -0.1rem -0.1rem 0.4rem rgb(250, 250, 250);
}
.app-yuan::before {
  content: " ";
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #1f5bcc;
  top: 12px;
  right: 16px;
  z-index: 2;
}
.app-content-yuan {
  width: 98%;
  height: 98%;
  background-color: #f2f4f8;
  border-radius: 50%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app-bike {
  width: 86%;
  height: 86%;
  box-shadow: 0.1rem 0.1rem 0.3rem #c8d0e7,
    -0.1rem -0.1rem 0.2rem rgb(250, 250, 250);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fonts-icon {
  display: flex;
  align-items: center;
  margin: 12px 0;
}
.fonts-icon span {
  font-size: 12px;
  color: red;
  margin: 0 4px;
}
.app-bike-image {
  width: 80%;
}
.app-bike-image img {
  width: 100%;
  display: flex;
}
.app-lock {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0.2rem 0.2rem 0.5rem #c8d0e7,
    -0.1rem -0.1rem 0.4rem rgb(250, 250, 250);
  margin: 0 auto;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app-lock span {
  font-size: 14px;
  color: red;
}
.app-state {
  display: flex;
  justify-content: space-between;
}
.app-state .app-left-module {
  width: 48%;
  height: 52px;
  box-shadow: 0.2rem 0.2rem 0.5rem #c8d0e7,
    -0.1rem -0.1rem 0.4rem rgb(250, 250, 250);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.app-left-top {
  display: flex;
  justify-content: center;
  align-items: center;
}
.app-left-top span:first-child {
  font-size: 12px;
  font-family: Cera Pro;
  font-weight: bold;
  color: #455060;
  transform: scale(0.5);
  display: block;
  width: 45px;
}
.app-left-top span:last-child {
  transform: rotate(90deg) scale(0.8);
  display: block;
}
.app-percentage {
  font-size: 14px;
  font-weight: bold;
}
.app-percentage span {
  font-size: 12px;
  font-weight: 400;
  transform: scale(0.3);
}
.app-state .app-right-module {
  width: 48%;
  height: 52px;
  background: linear-gradient(
    142deg,
    #2039e8 0%,
    #7554eb 39%,
    #b468ee 68%,
    #a175eb 77%,
    #2bc9db 100%
  );
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.app-right-module .app-percentage {
  color: #fff;
}
.app-loop {
  border-radius: 8px;
  width: 100%;
  overflow: hidden;
  margin: 7px 0;
}
.app-loop img {
  width: 100%;
  display: block;
}
.app-footer {
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
  box-sizing: border-box;
}
.app-footer div {
  width: 30px;
  height: 22px;
  box-shadow: 0.2rem 0.2rem 0.5rem #c8d0e7,
    -0.1rem -0.1rem 0.4rem rgb(250, 250, 250);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  background-color: #fff;
}
.app-footer div:nth-child(2) {
  background-color: #1f5bcc;
}
.app-footer div:first-child span {
  color: #1f5bcc;
  transform: scale(0.8);
}
.app-footer div:last-child span {
  color: #455060;
  transform: scale(0.8);
}
</style>